import { useNavigate } from "@tanstack/react-router"
import { getRefreshToken } from "./refreshTokenStorage"
import { useLogoutMutation } from "./api"
import { clearAuth } from "./slice"
import { withRefreshLock } from "./refreshLock"
import { useDispatch } from "@/base/store"

export default () => {
  const [logout] = useLogoutMutation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  return async () => {
    await navigate({ to: "/" }) // Avoids storing redirectUrl

    // Read, invalidate and clear under the refresh lock, or a refresh in flight in another tab can
    // write its replacement back after the clear, leaving a working token behind.
    await withRefreshLock(async () => {
      const refreshToken = getRefreshToken()
      if (refreshToken) {
        await logout(refreshToken)
      }
      dispatch(clearAuth())
    })
  }
}
